// FOURNOTHING — v5: header, filtros, compra rápida, galería, talle, barra fija.
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var smooth = reduce ? 'auto' : 'smooth';

  // Header: sombra al scrollear
  var fnh = document.getElementById('fnh');
  function onScroll() { if (fnh) fnh.classList.toggle('is-scrolled', window.scrollY > 24); }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // Filtros del home (Todo / Remeras / Gorras)
  document.querySelectorAll('[data-tabs]').forEach(function (tabs) {
    var grid = tabs.parentElement.querySelector('[data-grid]');
    if (!grid) return;
    tabs.addEventListener('click', function (e) {
      var b = e.target.closest('[data-filter]');
      if (!b) return;
      tabs.querySelectorAll('[data-filter]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
      var f = b.dataset.filter;
      grid.querySelectorAll('.pcard').forEach(function (c) { c.hidden = !(f === 'all' || c.dataset.type === f); });
    });
  });

  // Compra rápida desde la tarjeta
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-quick-add]');
    if (!b || b.disabled || typeof addToCart !== 'function') return;
    e.preventDefault();
    var orig = b.textContent;
    b.disabled = true;
    addToCart(b.dataset.quickAdd, 1).then(function () {
      b.textContent = '✓';
      if (typeof openCartDrawer === 'function') openCartDrawer();
    }).catch(function () { b.textContent = '×'; }).then(function () {
      setTimeout(function () { b.textContent = orig; b.disabled = false; }, 1300);
    });
  });

  // Galería de la ficha: puntitos en mobile
  var track = document.querySelector('[data-pdp-track]');
  var dots = document.querySelectorAll('[data-pdp-dots] span');
  if (track && dots.length) {
    track.addEventListener('scroll', function () {
      var mid = track.scrollLeft + track.clientWidth / 2, idx = 0, best = Infinity;
      Array.prototype.forEach.call(track.children, function (s, i) {
        var d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - mid);
        if (d < best) { best = d; idx = i; }
      });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }, { passive: true });
  }

  // Stock por talle + texto de la barra fija
  var vdata = null;
  try { vdata = JSON.parse(document.getElementById('pdp-variants').textContent); } catch (err) {}
  var stock = document.getElementById('pdp-stock');
  var barBtn = document.getElementById('pdp-bar-btn');
  document.addEventListener('click', function (e) {
    var s = e.target.closest('.size-btn');
    if (!s || s.disabled || !vdata) return;
    var v = vdata[s.dataset.variantId];
    var label = s.dataset.label;
    if (stock && v) {
      var last = v.q === 1;
      stock.dataset.state = last ? 'low' : 'ok';
      stock.querySelector('span').textContent = last ? 'Queda la última en talle ' + label : 'En stock en talle ' + label + ' · lista para entregar';
    }
    if (barBtn && !barBtn.disabled) barBtn.textContent = 'Agregar — talle ' + label;
  });

  // Barra fija de compra: aparece cuando el botón principal queda arriba
  var bar = document.getElementById('pdp-bar');
  var mainBtn = document.getElementById('add-to-cart-btn');
  if (bar && mainBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var en = entries[0];
      var show = !en.isIntersecting && en.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('fn-bar-on', show);
    }, { threshold: 0 }).observe(mainBtn);
    if (barBtn) barBtn.addEventListener('click', function () {
      var input = document.getElementById('variant-id');
      var needsSize = document.querySelectorAll('.size-btn').length > 0 && input && !input.value;
      if (needsSize) {
        var sizes = document.querySelector('.product-detail__sizes');
        if (sizes) sizes.scrollIntoView({ behavior: smooth, block: 'center' });
        var err = document.getElementById('size-error');
        if (err) err.style.display = 'block';
        return;
      }
      mainBtn.click();
    });
  }

  // ¿Cuál es mi talle?
  var finder = document.querySelector('[data-finder]');
  if (finder) {
    var table = [];
    try { table = JSON.parse(finder.dataset.table); } catch (err) {}
    var out = finder.parentElement.querySelector('[data-finder-out]');
    finder.addEventListener('submit', function (e) {
      e.preventDefault();
      var val = parseFloat(String(finder.querySelector('input').value).replace(',', '.'));
      if (!val || val < 30 || val > 100 || !table.length) { out.textContent = 'Poné el ancho en centímetros, por ejemplo 60.'; return; }
      var rec = null;
      for (var i = 0; i < table.length; i++) { if (table[i][1] >= val) { rec = table[i]; break; } }
      var biggest = table[table.length - 1];
      if (!rec) {
        out.innerHTML = 'Tu remera es más ancha que nuestra <strong>' + biggest[0] + '</strong> (' + biggest[1] + ' cm), que es la más grande.';
        rec = biggest;
      } else {
        out.innerHTML = 'Te recomendamos talle <strong>' + rec[0] + '</strong> (' + rec[1] + ' cm de ancho).';
      }
      var btn = document.querySelector('.size-btn[data-label="' + rec[0] + '"]');
      if (btn && !btn.disabled) out.innerHTML += ' <button type="button" class="fn-finder__pick" data-pick="' + rec[0] + '">Elegir ' + rec[0] + '</button>';
      else if (btn) out.innerHTML += ' Ese talle está agotado por ahora.';
    });
    document.addEventListener('click', function (e) {
      var p = e.target.closest('[data-pick]');
      if (!p) return;
      var btn = document.querySelector('.size-btn[data-label="' + p.dataset.pick + '"]');
      if (!btn) return;
      btn.click();
      var sizes = document.querySelector('.product-detail__sizes');
      if (sizes) sizes.scrollIntoView({ behavior: smooth, block: 'center' });
    });
  }
})();
